import { render, staticRenderFns } from "./LinkElementComponent.vue?vue&type=template&id=174d63dc&"
import script from "./LinkElementComponent.vue?vue&type=script&lang=ts&"
export * from "./LinkElementComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174d63dc')) {
      api.createRecord('174d63dc', component.options)
    } else {
      api.reload('174d63dc', component.options)
    }
    module.hot.accept("./LinkElementComponent.vue?vue&type=template&id=174d63dc&", function () {
      api.rerender('174d63dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/LinkElementComponent.vue"
export default component.exports